import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    externalLink: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        color: theme.palette.primary.main,
        display: 'flex !important',
        justifyContent: 'flex-start',
        padding: 0,
        width: 'fit-content',
    },
    openInNewIcon: {
        height: 14,
        marginLeft: '-4px',
        width: 14,
    },
}));

function ExternalLink({ children, className, id, url, ...props }) {
    const classes = useStyles();

    if (url.startsWith('http')) {
        props.component = 'a';
        props.href = url;
        props.target = '_blank';
    } else {
        props.component = Link;
        props.to = url;
    }

    return (
        <Button
            className={classNames(className, classes.externalLink)}
            disableRipple
            endIcon={<OpenInNewIcon className={classes.openInNewIcon} />}
            id={id}
            variant="text"
            {...props}
        >
            <Typography variant="body2">{children}</Typography>
        </Button>
    );
}

export default ExternalLink;
